import moment from "moment";

const formatDate = (value) => {
  if (!value || value === "0001-01-01T00:00:00Z") return "Н/Д";
  if (typeof value === "string" && /^\d{2}\.\d{2}\.\d{4}$/.test(value)) return value;
  return moment(value).format("DD.MM.YYYY");
};

export default formatDate;
